import { FC } from 'react';
import { Link } from 'react-router-dom';

import { OVERVIEW_DASHBOARD_PATH } from 'common/selectors/sidebar/affiliates';
import { LOGIN_PATH } from 'common/selectors/sidebar/common';

type ErrorNavigationPropTypes = {
  isLoggedIn: boolean;
};

const ErrorNavigation: FC<ErrorNavigationPropTypes> = ({ isLoggedIn }) =>
  isLoggedIn ? (
    <nav>
      <Link to={OVERVIEW_DASHBOARD_PATH}>Dashboard</Link>
    </nav>
  ) : (
    <nav>
      <Link to={LOGIN_PATH}>Login</Link>
    </nav>
  );

export default ErrorNavigation;
